export default {
  "l10n": {
    "date": {
      "months": {
        "full": ["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"],
        "abbr": ["ene.","feb.","mar.","abr.","may.","jun.","jul.","ago.","sep.","oct.","nov.","dic."]
      },
      "days": {
        "full": ["domingo","lunes","martes","miércoles","jueves","viernes","sábado"],
        "abbr": ["do.","lu.","ma.","mi.","ju.","vi.","sá."]
      },
      "patterns": {
        "longDate": "dddd, D MMMM YYYY",
        "dateSlash": "DD/MM/YYYY",
        "dateShort": "dddd D MMMM",
        "dateMedium": "dddd D MMMM - H[.]mm",
        "dateLarge": "D/MMM/YYYY [alle] HH[.]mm[.]ss",
        "timeShort": "LT",
        "timeMedium": "DD[/]MM LT"
      }
    },
    "number": {
      "patterns": {
        "standard": ["-n", "n"],
        "amount": ["-nS", "nS"]
      },
      "group": {
        "separator": ".",
        "length": 3,
        "abbr": ["", "k", "M", "B"]
      },
      "decimal": {
        "separator": ",",
        "length": 2
      },
      "ordinal": function(number) { return number + (number === 1 ? '°' : '°'); }
    }
  },
  "translations": {
    "messages": {
  " CASH ": [
    null,
    " BONUS "
  ],
  "!action:Deposit": [
    null,
    "Deposita"
  ],
  "!desc:AddCitizenCard": [
    null,
    "!desc:AddCitizenCard"
  ],
  "!desc:BetRefundOffer": [
    null,
    "Ti offriamo il doppio del tuo primo deposito fino a 200€<br /><br />Per festeggiare il tuo arrivo su Winamax, al momento del tuo primo deposito, approfitterai di due offerte di benvenuto: un bonus fino a 250€ e il doppio del tuo primo deposito in freebet fino a 200€*! Così potrai cominciare subito a scommettere.<br /><br />Le 2 offerte sono cumulabili e possono essere attivate automaticamente al momento del tuo primo deposito."
  ],
  "!desc:BetRefundOffer100": [
    null,
    "Il primo deposito offerto fino a 100€<br /><br />Per festeggiare il tuo arrivo su Winamax, al momento del tuo primo deposito, beneficierai di due offerte di benvenuto: un bonus fino a 250€ e l'importo del tuo primo deposito in freebet fino a 100€*! Potrai così cominciare subito a scommettere.<br /><br />Le due offerte sono cumulabili e si attivano automaticamente al momento del tuo primo deposito."
  ],
  "!desc:CondBetRefundOffer": [
    null,
    "*Prima di poter procedere al prelievo, l'importo del deposito iniziale deve essere puntato in scommesse sul sito Winamax.it (nel limite di 100€ se l'importo del deposito è superiore). Le scommesse annullate non sono prese in considerazione."
  ],
  "!desc:CondFirstDeposit": [
    null,
    "*L'offerta di primo deposito è valida una sola volta per utilizzatore, terminale (PC, tablet o smartphone), famiglia o conto bancario. L'offerta è riservata ai giocatori che non hanno mai effettuato un deposito su un conto Winamax (compreso un conto ormai chiuso)."
  ],
  "!desc:DefaultLandingContent": [
    null,
    "<div class=\"hide-for-small\">\n<p>Per festeggiare il tuo arrivo su Winamax, beneficerai di due offerte di benvenuto al momento del tuo primo deposito: <b>l’importo del tuo primo deposito in freebet fino a 100€ </b> e un <b>bonus fino a 250€!</b>*</p><br />\n<p>Le due offerte sono cumulabili e, secondo le tue preferenze, attivate automaticamente al momento del tuo primo deposito. </p><br />\n<p>Allora, cosa aspetti a iscriverti al sito che propone <b>il miglior bonus di benvenuto?</b></p><br />\n<h2> Come funziona?   </h2>\n<br />\n<p>Al momento del tuo primo deposito su Winamax, e prima di qualunque azione di gioco, ti offriamo l’importo del tuo deposito in freebet fino a 100€.\n<br />\nPer esempio, se depositi 100€ su Winamax, riceverai subito 100€ di freebet sul tuo conto per poter cominciare a scommettere. Le vincite nette ottenute con le freebet saranno versati sul tuo conto.\n<br />\nTi offriamo anche un bonus dal valore del tuo deposito fino a 250€. Il tuo conto Winamax sarà accreditato per tranche del 20% del valore del bonus ogni volta che avrai ottenuto abbastanza Miles (le Miles sono i punti fedeltà ottenuti giocando a poker e scommettendo). Per ogni € di bonus dovrai ottenere 30 Miles. Per esempio, se hai depositato 100€ come primo deposito, ti accrediteremo 20€ una volta raggiunte le 600 Miles, poi altri 20€ quando raggiungerai 1.200 Miles ecc. In totale riceverai 100€ una volta ottenuto 3.000 Miles.\n</p>\n<br />\n<p><small><i>*L'offerta di primo deposito è valida una sola volta per utente, terminal (computer, table o smartphone), abbonamento internet o conto bancario. L’offerta è riservata ai giocatori che non hanno mai effettuato un deposito su un conto Winamax (compresi i conti ormai chiusi). <a href=\"/www.winamax.it/bonus-primo-deposito\" target=\"_blank\"> Vedi tutte le condizioni</i></a>.</small></p>\n</div>\n<div class=\"show-for-small-only\">\n<p>Per festeggiare il tuo arrivo su Winamax, beneficerai di due offerte di benvenuto al momento del tuo primo deposito: <b> un bonus fino a 250 €</b>* e <b> l’importo del tuo primo deposito in freeebet fino a 100€!!</b>**</p><br />\n<p> Le due offerte sono cumulabili e, secondo le tue preferenze, attivate automaticamente al momento del tuo primo deposito. </p><br />\n<p> Allora, cosa aspetti a iscriverti al sito che propone <b>il miglior bonus di benvenuto?</b> ?</p><br /><br />\n</div>\n"
  ],
  "!desc:DefaultLandingContentES": [
    null,
    "!desc:DefaultLandingContentES"
  ],
  "!desc:DefaultLandingMobileContent": [
    null,
    "<h2> Come funziona? </h2>\n<br />\n<p>Al momento del tuo primo deposito su Winamax, e prima di ogni azione di gioco, ti offriamo l’importo del tuo deposito in freebet fino a 100€.\n<br />\nPer esempio, se depositi 100€ su Winamax, riceverai subito 100€ di freebet sul tuo conto per poter cominciare a scommettere. Le vincite nette ottenute con le freeebet saranno versate sul tuo conto. \n<br />\nTi offriamo anche un bonus dal valore del tuo deposito fino a 250€. Il tuo conto Winamax sarà accreditato per tranche del 20% del valore del bonus ogni volta che avrai ottenuto abbastanza Miles (le Miles sono i punti fedeltà ottenuti giocando a poker e scommettendo). Per ogni € di bonus dovrai ottenere 30 Miles. Per esempio, se hai depositato 100€ come primo deposito, ti accrediteremo 20€ una volta raggiunte le 600 Miles, poi altri 20€ quando raggiungerai 1.200 Miles, ecc. In totale riceverai 100€ una volta ottenuto 3.000 Miles.\n<br /><br />\n<p><small><i>*L'offerta di primo deposito è valida una sola volta per utente, terminal (computer, table o smartphone), abbonamento internet o conto bancario. L’offerta è riservata ai giocatori che non hanno mai effettuato un deposito su un conto Winamax (compresi i conti ormai chiusi). <a href=\"/www.winamax.it/bonus-primo-deposito\" target=\"_blank\"> Vedi tutte le condizioni</i></a>.</small></p>\n"
  ],
  "!desc:DefaultLandingPageTitleES": [
    null,
    "!desc:DefaultLandingPageTitleES"
  ],
  "!desc:DefaultLandingTitleES": [
    null,
    "!desc:DefaultLandingTitleES"
  ],
  "!desc:SpecialOfferLandingContent": [
    null,
    "<div class=\"hide-for-small\">\n<p>Per festeggiare il tuo arrivo su Winamax, approfitta di due offerte di benvenuto per il tuo primo deposito: <b>il doppio del tuo primo deposito in bonus scommesse fino a 200€</b> e un <b>bonus fino a 250€!</b>*.</p><br />\n\n<p>Le due offerte sono cumulabili e si attivano automaticamente al momento del tuo primo deposito.</p><br />\n\n<p>Allora, cosa aspetti a iscriverti sul sito che propone <b>il miglior bonus di benvenuto?</b></p><br />\n\n<h2> Come funziona?</h2>\n<br />\n<p> Al momento del tuo primo deposito su Winamax e prima ancora di aver scommesso o giocato a poker, ti offriamo il doppio del tuo deposito in bonus scommesse fino 200€.</p>\n\n<p> Per esempio, se depositi 100€ su Winamax, riceverai subito 200€ di bonus scommesse sul tuo conto di gioco per poter cominciare a scommettere. Le vincite nette ottenute saranno versate sul tuo conto.</p>\n<br />\n<p>Ti offriamo anche un bonus dello stesso valore del tuo deposito fino a 250€. Il tuo conto sarà accreditato per tranche del 20% del valore del bonus ogni volta che avrai ottenuto le miglia necessarie (le Miglia sono i punti fedeltà ottenuti giocando a poker e scommettendo). Per ottenere 1€ di bonus ti basterà accumulare 30 Miglia. In questo modo, se il tuo primo deposito è di 100€, accrediteremo il tuo conto di 20€ quando avrai raggiunto 600 Miglia, poi altri 20€ quando otterrai 1.200 Miglia, ecc. In totale, ti verseremo 100€ quando avrai raggiunto 3.000 Miglia.</p>\n<br />\n<p><small><i>*L’offerta di primo deposito è valida una sola volta per utilizzatore, terminale (computer, tablet o smartphone) o conto bancario ed è riservata ai giocatori che non hanno mai effettuato un deposito su un conto di gioco Winamax (compresi i conti ormai chiusi). <a href=\"/bonus-primo-deposito \" target=\"_blank\">Vedi tutte le condizioni</a></i></small></p>\n</div>\n\n<div class=\"show-for-small-only\">\n<p>Per festeggiare il tuo arrivo su Winamax, approfitta di due offerte di benvenuto per il tuo primo deposito: <b>il doppio del tuo primo deposito in bonus scommesse fino a 200€</b> e <b>bonus fino a 250€</b>*.</p><br />\n\n<p>Le due offerte sono cumulabili e si attivano automaticamente al momento del tuo primo deposito.</p><br />\n\n<p>Allora cosa aspetti a iscriverti sul sito che propone <b>il miglior bonus di benvenuto?</b></p><br />\n\n<p><small><i>*L’offerta di primo deposito è valida una sola volta per utilizzatore, terminale (computer, tablet o smartphone) o conto bancario ed è riservata ai giocatori che non hanno mai effettuato un deposito su un conto di gioco Winamax (compresi i conti ormai chiusi). <a href=\"/bonus-primo-deposito \" target=\"_blank\">Vedi tutte le condizioni</a></i></small></p>\n</div>"
  ],
  "!desc:SpecialOfferLandingMobileContent": [
    null,
    "<h2>Come funziona?</h2>\n<br />\n<p>Al momento del tuo primo deposito su Winamax e prima ancora di aver scommesso o giocato a poker, ti offriamo il doppio del tuo deposito in bonus scommesse fino 200€.</p>\n\n<p>Per esempio, se depositi 100€ su Winamax, riceverai subito 200€ di bonus scommesse sul tuo conto di gioco per poter cominciare a scommettere. Le vincite nette ottenute saranno versate sul tuo conto.</p>\n<br />\n<p>Ti offriamo anche un bonus dello stesso valore del tuo deposito fino a 250€. Il tuo conto sarà accreditato per tranche del 20% del valore del bonus ogni volta che avrai ottenuto le Miles necessarie (le Miles sono i punti fedeltà ottenuti giocando a poker e scommettendo). Per ottenere 1€ di bonus ti basterà accumulare 30 Miles. In questo modo, se il tuo primo deposito è di 100€, accrediteremo il tuo conto di 20€ quando avrai raggiunto 600 Miles, poi altri 20€ quando otterrai 1.200 Miles, ecc. In totale, ti verseremo 100€ quando avrai raggiunto 3.000 Miles.</p>\n<br />\n<p><small><i>*L’offerta di primo deposito è valida una sola volta per utilizzatore, terminale (computer, tablet o smartphone) o conto bancario ed è riservata ai giocatori che non hanno mai effettuato un deposito su un conto di gioco Winamax (compresi i conti ormai chiusi). <a href=\"/bonus-primo-deposito \" target=\"_blank\">Vedi tutte le condizioni</a></i></small></p>"
  ],
  "!placeholder:dd": [
    null,
    "gg"
  ],
  "!placeholder:mm": [
    null,
    "mm"
  ],
  "!placeholder:yy": [
    null,
    "aa"
  ],
  "!placeholder:yyyy": [
    null,
    "aaaa"
  ],
  ", if you lost": [
    null,
    ", se perdente"
  ],
  "1st bet refunded up to €100": [
    null,
    "Prima scommessa rimborsata fno a 100€"
  ],
  "A photo of the back of your ID document will also be required to validate your account.": [
    null,
    "Per validare il tuo conto di gioco devi inviare una copia fronte/retro del tuo documento."
  ],
  "A receipt for your rent": [
    null,
    "Ricevuta affitto"
  ],
  "Above": [
    null,
    "Oltre"
  ],
  "Acceptable ID": [
    null,
    "Documenti accettati"
  ],
  "Acceptable formats: %1$s.": [
    null,
    "Formati accettati: %1$s."
  ],
  "Acceptable proof of address documents": [
    null,
    "Giustificativo di domicilio"
  ],
  "Account already exist": [
    null,
    "Conto già esistente"
  ],
  "Account creation complete": [
    null,
    "Creazione del conto completata"
  ],
  "Account creation: complete.<br />That's what<br />we're talking about!": [
    null,
    "Creazione del conto completata. <br />Ben fatto!<br />"
  ],
  "Account number": [
    null,
    "Numero del conto"
  ],
  "Activation code": [
    null,
    "Codice di attivazione"
  ],
  "Add a bank card": [
    null,
    "Aggiungi una carta di credito/debito"
  ],
  "Add my bank card": [
    null,
    "Aggiungi carta di credito/debito"
  ],
  "Add my bank card details": [
    null,
    "Aggiungi dati della carta di credito/debito"
  ],
  "Address details": [
    null,
    "Dettagli indirizzo"
  ],
  "All countries": [
    null,
    "Paesi"
  ],
  "An error has occured when checking your CAPTCHA score. Please try again later.": [
    null,
    "Si è verificato un errore durante il controllo del risultato CAPTHCA. Ti invitiamo a riprovare più tardi."
  ],
  "Analysis": [
    null,
    "Analisi"
  ],
  "Automatic withdrawal": [
    null,
    "Prelievo automatico"
  ],
  "Automatic withdrawal threshold": [
    null,
    "Soglia di prelievo automatico"
  ],
  "BOOM! You can start playing!": [
    null,
    "BOOM! Puoi cominciare a giocare!"
  ],
  "Back": [
    null,
    "Indietro"
  ],
  "Back to homepage": [
    null,
    "Torna alla home"
  ],
  "Bank": [
    null,
    "Banca"
  ],
  "Bank accounts from this country are not accepted on Winamax": [
    null,
    "I conti bancari con sede in questo paese non sono accettati da Winamax"
  ],
  "Bank card number": [
    null,
    "Numero di carta"
  ],
  "Bank code": [
    null,
    "Codice ABI"
  ],
  "Bank details": [
    null,
    "Informazioni bancarie"
  ],
  "Bank office": [
    null,
    "Codice CAB"
  ],
  "Before any action even made on our site, we offer you your initial deposit in Freebets, up to €100.": [
    null,
    "Al momento del tuo arrivo su Winamax ti offriamo il tuo deposito iniziale in freebet fino a 100€."
  ],
  "Beginner": [
    null,
    "Principiante"
  ],
  "Beginner profile token": [
    null,
    "Token profilo principiante"
  ],
  "Beneficiary": [
    null,
    "Beneficiario"
  ],
  "Bet on sports": [
    null,
    "Scommetti sullo sport"
  ],
  "Betting limit - Poker": [
    null,
    "Limiti di puntata - Poker"
  ],
  "Betting limit - Sport betting": [
    null,
    "Limiti di puntata - Scommesse"
  ],
  "Birth date": [
    null,
    "Data di nascita"
  ],
  "Birth name": [
    null,
    "Cognome di nascita"
  ],
  "Bonus up to €250": [
    null,
    "Bonus fino a 250€"
  ],
  "Boom!": [
    null,
    "Boom!"
  ],
  "By ticking this box, you agree that you have read and accepted our": [
    null,
    "Selezionando questa casella confermi di aver letto e accettato i nostri"
  ],
  "CAPTCHA score error. Please try again. You will automatically be redirected to the Winamax website. (%1$s)": [
    null,
    "Errore CAPTCHA. Ti invitiamo a riprovare. Verrai reindirizzato automaticamente al sito web Winamax. (%1$s)"
  ],
  "Card number": [
    null,
    "Numero di carta"
  ],
  "Change address": [
    null,
    "Modifica indirizzo"
  ],
  "Change my deposit limit": [
    null,
    "Modifica limite di deposito"
  ],
  "Change my limit": [
    null,
    "Modifica limite"
  ],
  "Change your account details in order to receive your activation code by post.": [
    null,
    "Per ricevere il tuo codice di attivazione per posta devi modificare i tuoi dati personali."
  ],
  "Check that your bank card information is accurate and complete the cryptogram.": [
    null,
    "Controlla se i dati della tua carta sono corretti e completi di criptogramma."
  ],
  "Choose a deposit method in order to make your first deposit.": [
    null,
    "Per effettuare il primo deposito devi selezionare un metodo di pagamento."
  ],
  "Choose a deposit method.": [
    null,
    "Seleziona un metodo di pagamento."
  ],
  "Choose the amount of your first deposit in order to start playing.": [
    null,
    "Per cominciare a giocare devi selezionare l'importo del primo deposito."
  ],
  "Choose the amount you wish to deposit in order to continue playing.": [
    null,
    "Per continuare a giocare devi selezionare l'importo che vuoi depositare."
  ],
  "Choose the maximum amount you wish to deposit per month.": [
    null,
    "Scegli l'importo massimo mensile che desideri depositare."
  ],
  "Choose the maximum amount you wish to deposit per week.": [
    null,
    "Scegli l'importo massimo settimanale di deposito."
  ],
  "Choose the profile that best suits your playing style! You can also change the values manually.": [
    null,
    "Scegli il profilo più adatto al tuo stile di gioco! Puoi modificare i valori anche manualmente."
  ],
  "Choose which bank card you want to use to make a deposit.": [
    null,
    "Seleziona la carta che vuoi utilizzare per effettuare un deposito."
  ],
  "Choose your country code": [
    null,
    "Scegli codice paese"
  ],
  "Choose your limit well in order to take advantage of your <b>first bet refunded up to €100</b>": [
    null,
    "Seleziona bene il tuo limite per approfittare della tua <b>prima scommessa rimborsata fino a 100€</b>."
  ],
  "Choose your username, but choose well!!<br />You need to have a kick-ass username to stand out in society.": [
    null,
    "Scegli il tuo username, ma scegli bene! <br /> Devi avere un bell'username per farti notare!"
  ],
  "Citizen card": [
    null,
    "Carta di identità"
  ],
  "Citizen card number": [
    null,
    "Numero di documento"
  ],
  "City": [
    null,
    "Luogo di nascita"
  ],
  "Click & drag your file here": [
    null,
    "Trascina il file qui"
  ],
  "Close": [
    null,
    "Chiudi"
  ],
  "Come and take a seat": [
    null,
    "Vieni, siediti pure"
  ],
  "Complete registration now": [
    null,
    "Completa adesso la tua iscrizione"
  ],
  "Confirm limit": [
    null,
    "Conferma limite"
  ],
  "Confirm my details": [
    null,
    "Conferma dati"
  ],
  "Confirm my limit": [
    null,
    "Conferma limite"
  ],
  "Confirm your details in order to receive a new activation code by post.": [
    null,
    "Conferma i tuoi dati per ricevere per posta un nuovo codice di attivazione."
  ],
  "Continue": [
    null,
    "Continua"
  ],
  "Continue my deposit": [
    null,
    "Procedi col deposito"
  ],
  "Continue with PayPal": [
    null,
    "Continua con PayPal"
  ],
  "Country": [
    null,
    "Paese"
  ],
  "Country of birth": [
    null,
    "Paese di nascita"
  ],
  "Country of residence": [
    null,
    "Stato di residenza"
  ],
  "Create my account": [
    null,
    "Crea il mio conto"
  ],
  "Creation": [
    null,
    "Creazione"
  ],
  "Cryptogram": [
    null,
    "Criptogramma"
  ],
  "Deposit": [
    null,
    "Deposita"
  ],
  "Deposit limit": [
    null,
    "Limite di deposito"
  ],
  "Deposit on my account": [
    null,
    "Deposita sul conto"
  ],
  "Deposit on your Winamax account by bank transfer": [
    null,
    "Deposita sul tuo conto Winamax tramite bonifico"
  ],
  "Deposit on your account with Neteller.": [
    null,
    "Deposita sul tuo conto con Neteller."
  ],
  "Deposit with Moneybookers/Skrill.": [
    null,
    "Deposita con Moneybookers/Skrill."
  ],
  "Document": [
    null,
    "Documento"
  ],
  "Document number": [
    null,
    "Numero di documento"
  ],
  "Driver's licence": [
    null,
    "Patente di guida"
  ],
  "Driver's license": [
    null,
    "Patente di guida"
  ],
  "Driver's license: whole document with photo or front and back sides": [
    null,
    "Patente di guida: fronte"
  ],
  "Edit email/phone number": [
    null,
    "Modifica email/numero di telefono"
  ],
  "Email": [
    null,
    "Email"
  ],
  "Employed worker": [
    null,
    "Impiegato"
  ],
  "Enter a different amount": [
    null,
    "Inserisci un altro importo"
  ],
  "Enter amount": [
    null,
    "Inserisci importo"
  ],
  "Enter my information": [
    null,
    "Inserisci dati personali"
  ],
  "Enter the activation code sent to you by post.": [
    null,
    "Inserisci il codice di attivazione che hai ricevuto per posta."
  ],
  "Enter the code sent by text message to %1$s to verify your phone number.": [
    null,
    "Inserisci il codice inviato tramite SMS per verificare il tuo numero di telefono."
  ],
  "Experienced": [
    null,
    "Esperto"
  ],
  "Experienced profile token": [
    null,
    "Token profilo esperto"
  ],
  "Expiry date": [
    null,
    "Data di scadenza"
  ],
  "Feel free to discover the platform at a later date if you so wish.": [
    null,
    "Sentiti libero di scoprire la piattaforma più tardi se preferisci."
  ],
  "Female": [
    null,
    "F"
  ],
  "Fill in my details": [
    null,
    "Completa dati"
  ],
  "Fill out the following form. Or directly fill out the informations with Paypal": [
    null,
    "Compila il seguente modulo. Oppure compila direttamente le tue informazioni con Paypal"
  ],
  "Fill out the form with your bank card information.": [
    null,
    "Compila il modulo con i dati della tua carta di credito/debito."
  ],
  "First deposit": [
    null,
    "Primo deposito"
  ],
  "First name": [
    null,
    "Nome"
  ],
  "For a Spanish nationality, you must supply us with a DNI and not a NIE": [
    null,
    "Per una nazionalità spagnola devi inviarci un DNI e non un NIE"
  ],
  "For a foreign nationality, you must supply us with a NIE and not a DNI": [
    null,
    "Per una nazionalità straniera devi inviarci un NIE e non un DNI"
  ],
  "Free registration": [
    null,
    "Iscrizione gratuita"
  ],
  "Full name on card": [
    null,
    "Nome e cognome sulla carta"
  ],
  "GG!<br />Your account has<br />been validated!": [
    null,
    "Congratulazioni!<br />Il tuo conto di gioco<br />è stato validato!"
  ],
  "Gambling is prohibited for minors": [
    null,
    "Il gioco è vietato \nai minori di anni 18"
  ],
  "General Terms and Conditions": [
    null,
    "Termini e Condizioni"
  ],
  "Health card: front and back": [
    null,
    "Tessera sanitaria: fronte/retro"
  ],
  "Hold on": [
    null,
    "Attendi"
  ],
  "I accept the ": [
    null,
    "Accetto i "
  ],
  "I agree to gain access to all": [
    null,
    "Accetto di partecipare a tutte le promozioni di"
  ],
  "I certify that I own this bank account": [
    null,
    "Dichiaro di essere il proprietario di questo conto bancario"
  ],
  "I have not received my code": [
    null,
    "Non ho ricevuto il codice"
  ],
  "I have read and accept the": [
    null,
    "Ho letto e accetto i"
  ],
  "I need a new code": [
    null,
    "Invia nuovo codice"
  ],
  "I want to receive offers and news": [
    null,
    "Voglio ricevere offerte e news"
  ],
  "I will deposit later": [
    null,
    "Farò un deposito più tardi"
  ],
  "I will send it at a later time": [
    null,
    "Lo invierò più tardi"
  ],
  "I would like to receive the newsletter and be kept up to date on all the latest bonuses and promotions": [
    null,
    "Desidero ricevere la newsletter ed essere informato su tutti gli ultimi bonus e promozioni"
  ],
  "IBAN": [
    null,
    "IBAN"
  ],
  "IBAN number": [
    null,
    "IBAN"
  ],
  "ID card: front and back": [
    null,
    "Carta d'identità: recto/verso"
  ],
  "ID card: front side": [
    null,
    "Documento d'identità: fronte/retro"
  ],
  "Identity card": [
    null,
    "Carta di identità"
  ],
  "Identity document number": [
    null,
    "Numero documento di identità"
  ],
  "Identity not verified": [
    null,
    "Codice fiscale non valido"
  ],
  "If you are not resident in Germany, you can register on": [
    null,
    "Se non risiedi in Germania puoi iscriverti su"
  ],
  "Important! Make sure you add the folloing reference for your transfer:": [
    null,
    "Importante! Assicurati di aggiungere questa causale per il tuo bonifico:"
  ],
  "In 30 seconds": [
    null,
    "In 30 secondi"
  ],
  "In order to make your deposit, add your bank card or any other deposit method.": [
    null,
    "Aggiungi un carta di credito/debito o un altro metodo di pagamento per effettuare un deposito."
  ],
  "In order to make your first deposit, add your bank card or any other deposit method.": [
    null,
    "Aggiungi un carta di credito/debito o un altro metodo di pagamento per effettuare il tuo primo deposito."
  ],
  "In order to play for real money, you must send us a proof of address.": [
    null,
    "Per poter giocare ai tavoli con soldi veri devi inviarci un tuo giustificativo di domicilio"
  ],
  "In order to play for real money, you must send us an ID.": [
    null,
    "Per poter giocare ai tavoli con soldi veri devi inviarci un tuo documento di identità."
  ],
  "In order to validate your account, you must upload a photo of your ID.": [
    null,
    "Per validare il tuo conto devi caricare una foto del tuo documento."
  ],
  "Incorrect format in this field": [
    null,
    "Formato non corretto"
  ],
  "Incorrect tax code": [
    null,
    "Codice fiscale errato"
  ],
  "Incorrect value in this field, the department does not match the city.": [
    null,
    "Campo non valido, la provincia inserita non corrisponde a quella del luogo indicato."
  ],
  "Independent professional": [
    null,
    "Libero professionista"
  ],
  "Internal error": [
    null,
    "Errore interno"
  ],
  "Invalid NIE support number format. This must start with the letter \"E\" or \"C\" and be followed by 8 numbers.": [
    null,
    "Formato del numero di supporto NIE non valido. Deve cominciare con una E o con una C e deve essere seguito da 8 cifre."
  ],
  "Invalid phone number format.": [
    null,
    "Numero di telefono non valido."
  ],
  "It seems there is a connection problem": [
    null,
    "Problema di connessione"
  ],
  "It would be a shame to stop so close to the finish line!": [
    null,
    "Sarebbe un peccato fermarti così vicino al traguardo!"
  ],
  "It's time to get serious": [
    null,
    "È tempo di passare alle cose serie"
  ],
  "Join Winamax and take advantage of our welcome offer!": [
    null,
    "Iscriviti su Winamax e approfitta della nostra offerta di benvenuto!"
  ],
  "Keep an <br />eye on your<br />dough!": [
    null,
    "Tieni <br />d'occhio<br />le tue finanze!"
  ],
  "Last name": [
    null,
    "Cognome"
  ],
  "Last<br />sprint!": [
    null,
    "Un ultimo<br />sforzo!"
  ],
  "Leave": [
    null,
    "Esci"
  ],
  "Leave registration": [
    null,
    ""
  ],
  "Leaving us already?": [
    null,
    "Ci lasci già?"
  ],
  "Loading...": [
    null,
    "Caricamento..."
  ],
  "Log in": [
    null,
    "Accedi"
  ],
  "Make a deposit": [
    null,
    "Effettua un deposito"
  ],
  "Male": [
    null,
    "M"
  ],
  "Maximum amount per month": [
    null,
    "Importo massimo mensile"
  ],
  "Maximum amount per week": [
    null,
    "Importo massimo settimanale"
  ],
  "Missing application initialization parameters. Please try again.": [
    null,
    "Parametri di inizializzazione dell'applicazione mancanti. Ti invitiamo a riprovare più tardi."
  ],
  "Moneybookers email": [
    null,
    "Email Moneybookers"
  ],
  "Must contain at least 3 of the following characters: (0-9), (a-z), (A-Z) and symbols (ex @, !, #, $).": [
    null,
    "La password deve contenere almeno 3 delle seguenti tipologie di caratteri: (0-9), (a-z), (A-Z) e simboli (es: @, !, #, $)."
  ],
  "NIE number": [
    null,
    "Numero supporto NIE"
  ],
  "Nationality": [
    null,
    "Nazionalità"
  ],
  "Neteller Secure ID": [
    null,
    "Neteller Secure ID"
  ],
  "Neteller account": [
    null,
    "Conto Neteller"
  ],
  "No godfather found for this code": [
    null,
    "Nessun amico invitante trovato per questo codice"
  ],
  "No minors": [
    null,
    "Vietato ai minori di anni 18"
  ],
  "Occupation": [
    null,
    "Occupazione"
  ],
  "Ok": [
    null,
    "Ok"
  ],
  "Oops,": [
    null,
    "Ops,"
  ],
  "Open your account": [
    null,
    "Creazione del conto di gioco"
  ],
  "Optional": [
    null,
    "Opzionale"
  ],
  "Other": [
    null,
    "Altro"
  ],
  "Other deposit methods": [
    null,
    "Altri metodi di pagamento"
  ],
  "Other document": [
    null,
    "Altro documento"
  ],
  "Other suggestions": [
    null,
    "Altri dati"
  ],
  "Our bank details for your transfer:": [
    null,
    "Informazioni bancarie per il bonifico:"
  ],
  "Passport": [
    null,
    "Passaporto"
  ],
  "Passport: whole page with photo": [
    null,
    "Passaporto: pagina con foto"
  ],
  "Password": [
    null,
    "Password"
  ],
  "Per month": [
    null,
    "Mensile"
  ],
  "Per week": [
    null,
    "Settimanale"
  ],
  "Personal information": [
    null,
    "Dati personali"
  ],
  "Phone number": [
    null,
    "Telefono"
  ],
  "Phone, internet, water, gas or electricity bills": [
    null,
    "Bolletta del telefono, internet, acqua, gas, elettricità, ecc."
  ],
  "Place of birth": [
    null,
    "Luogo di nascita"
  ],
  "Play on the app !": [
    null,
    "Gioca sull'app!"
  ],
  "Play poker": [
    null,
    "Gioca a poker"
  ],
  "Play time - Poker": [
    null,
    "Tempo di gioco - Poker"
  ],
  "Poker Terms and Conditions": [
    null,
    "Termini e Condizioni poker"
  ],
  "Postal address": [
    null,
    "Indirizzo"
  ],
  "Postal code": [
    null,
    "Codice postale"
  ],
  "Privacy Policy": [
    null,
    "Trattamento dei dati personali"
  ],
  "Privacy and Cookies Policy": [
    null,
    "Informativa sul trattamento dei dati personali"
  ],
  "Processing": [
    null,
    "Elaborazione"
  ],
  "Protect your behind!": [
    null,
    "Proteggiti le spalle!"
  ],
  "Protect<br />your<br />behind!": [
    null,
    "Meglio <br />proteggersi<br />!"
  ],
  "Province": [
    null,
    "Provincia"
  ],
  "RIB key": [
    null,
    "Numeri di controllo"
  ],
  "Reference": [
    null,
    "Numero identificativo"
  ],
  "Referral": [
    null,
    "L'amico che ti ha invitato"
  ],
  "Referral code": [
    null,
    "Codice amico"
  ],
  "Region of birth": [
    null,
    "Provincia di nascita"
  ],
  "Register": [
    null,
    "Iscrizione"
  ],
  "Register with my email": [
    null,
    "Iscriviti con email"
  ],
  "Register with my phone number": [
    null,
    "Iscriviti con numero di telefono"
  ],
  "Registration": [
    null,
    "Iscrizione"
  ],
  "Registration complete!": [
    null,
    "Iscrizione completata!"
  ],
  "Registration not allowed from this country of residence.": [
    null,
    "Non puoi creare un conto di gioco da questo paese di residenza."
  ],
  "Regular": [
    null,
    "Intermedio"
  ],
  "Regular profile token": [
    null,
    "Token profilo intermedio"
  ],
  "Residence permit: front and back": [
    null,
    "Permesso di residenza: fronte/retro"
  ],
  "Responsible gaming": [
    null,
    "Gioco responsabile"
  ],
  "Retired": [
    null,
    "Pensionato"
  ],
  "SWIFT code": [
    null,
    "Codice SWIFT"
  ],
  "Save this card for future deposits": [
    null,
    "Salva la carta per i prossimi depositi"
  ],
  "Scan my ID": [
    null,
    "Scannerizza documento"
  ],
  "Scan my bank card": [
    null,
    "Scannerizza carta di credito/debito"
  ],
  "Scan my verification document": [
    null,
    "Scannerizza documento"
  ],
  "Search": [
    null,
    "Cerca"
  ],
  "See Ts&Cs for the offer": [
    null,
    "Vedi i Termini e Condizioni dell'offerta"
  ],
  "See accepted verification documents": [
    null,
    "Vedi i documenti d'identità accettati"
  ],
  "See what IDs we accept": [
    null,
    "Vedi documenti accettati"
  ],
  "Select your file": [
    null,
    "Seleziona file"
  ],
  "Self-employed": [
    null,
    "Lavoratore autonomo"
  ],
  "Send ID": [
    null,
    "Invia documento"
  ],
  "Send back of document": [
    null,
    "Invia di nuovo il documento"
  ],
  "Send documents": [
    null,
    "Invia documento"
  ],
  "Send my ID": [
    null,
    "Invia documento"
  ],
  "Send my new code": [
    null,
    "Invia nuovo codice"
  ],
  "Send my verification documents": [
    null,
    "Invia documento"
  ],
  "Send proof of identity": [
    null,
    "Invia il tuo documento"
  ],
  "Sex": [
    null,
    "Sesso"
  ],
  "Show<br />us who<br />you are!": [
    null,
    "Mostra<br />cosa<br />sai fare!"
  ],
  "Skip this step": [
    null,
    "Salta"
  ],
  "Skrill email": [
    null,
    "Email Skrill"
  ],
  "Social security card": [
    null,
    "Carta sicurezza sociale"
  ],
  "Sports betting Terms and Conditions": [
    null,
    "Termini e Condizioni scommesse"
  ],
  "Starting at €%1$s": [
    null,
    "A partire da %1$s€"
  ],
  "Student": [
    null,
    "Studente"
  ],
  "Successfully uploaded!": [
    null,
    "Caricamento avvenuto con successo!"
  ],
  "Super-player created!": [
    null,
    "Super giocatore creato!"
  ],
  "Surname": [
    null,
    "Secondo Cognome"
  ],
  "Take 2 minutes to create your account.": [
    null,
    "Bastano due minuti per creare il tuo conto."
  ],
  "Tax Code": [
    null,
    "Codice fiscale"
  ],
  "Tax bill or home insurance letter": [
    null,
    "Fattura fiscale o assicurazione sulla casa"
  ],
  "Terms and Conditions": [
    null,
    "Termini e Condizioni"
  ],
  "The activation code cannot be over %1$s characters.": [
    null,
    "Il codide di attivazione non deve superare i %1$s caratteri."
  ],
  "The activation code is not valid.": [
    null,
    "Codice di attivazione non valido."
  ],
  "The best odds are your odds": [
    null,
    "Le migliori quote sono le tue quote"
  ],
  "The current process seems to be slow. Try again.": [
    null,
    "Il processo sembra essere lento. Riprova."
  ],
  "The identity verification service is unavailable. Please try again later.": [
    null,
    "Il servizio di verifica dell'identità non è disponibile. Ti invitiamo e riprovare più tardi."
  ],
  "The maximum amount of time (in hours) you can spend at the poker tables each week.": [
    null,
    "Il tempo massimo (in ore) che puoi trascorrere ai tavoli da poker ogni settimana."
  ],
  "The maximum amount you can deposit into your account each week for sports betting and poker.": [
    null,
    "L'importo massimo che puoi depositare sul tuo conto di gioco ogni settimana."
  ],
  "The maximum cumulative amount you can bet on poker each week.": [
    null,
    "L'importo massimo totale che puoi scommettere sul poker ogni settimana."
  ],
  "The maximum cumulative amount you can bet on sports betting each week.": [
    null,
    "L'importo massimo totale che puoi scommettere sulle scommesse ogni settimana."
  ],
  "The registration process is only available for Portuguese citizens.": [
    null,
    "La registrazione è valida unicamente per i cittadini portoghesi."
  ],
  "The welcome bonus is linked to your first deposit. Set an amount of €100 (or more) to maximise your bonus!": [
    null,
    "L'offerta di benvenuto dipende dal tuo primo deposito. Deposita 100€ (o più) per approfittarne al massimo!"
  ],
  "There already exists an account with this email address.": [
    null,
    "Esiste già un conto associato a questo indirizzo email."
  ],
  "These deposit methods are not available for this amount.": [
    null,
    "Metodi di pagamento indisponibili per questo importo."
  ],
  "This code is required to create your account.": [
    null,
    "Il codice è necessario per la creazione del conto."
  ],
  "This document must mention your name and IBAN number.": [
    null,
    "Il documento deve menzionare il tuo nome e il tuo IBAN."
  ],
  "This field is mandatory to validate your deposit.": [
    null,
    "Campo obbligatorio per confermare il deposito."
  ],
  "This file format is invalid. Please try in one of the following formats: %1$s.": [
    null,
    "Formato non valido. Formati accettati: %1$s."
  ],
  "This fiscal code is already linked to an active account": [
    null,
    "Questo codice fiscale è già utilizzato da un conto attivo"
  ],
  "This limit can be changed at any time in your account.": [
    null,
    "Questo limite può essere modificato in qualsiasi momento."
  ],
  "This limit is mandatory for your account validation.": [
    null,
    "Questo limite è obbligatorio per la creazione del tuo conto."
  ],
  "This password does not contain at least 3 of the following: (0-9), (a-z), (A-Z) and symbols (e.g. @, !, #, $)": [
    null,
    "La password non contiene almeno 3 delle seguenti tipologie di caratteri: numeri (0-9), minuscole (a-z), maiuscole (A-Z) e simboli (es: @, !, #, $)"
  ],
  "This referral code is not valid.": [
    null,
    "Questo codice non è valido"
  ],
  "This threshold can be changed at any time from your account.": [
    null,
    "Questa soglia può essere modificata in qualsiasi momento."
  ],
  "This username is unavailable.": [
    null,
    "Username non valido."
  ],
  "This way for<br />money": [
    null,
    "Da questa parte per<br /> prelevare"
  ],
  "To finish your account validation, please upload a proof of bank account's property.": [
    null,
    "Per terminare la convalida del tuo conto devi caricare un documento che attesti la tua proprietà del conto bancario."
  ],
  "Too many attempts with this identity. Please try again later.": [
    null,
    "Troppi tentativi di accesso. Ti invitiamo a riprovare più tardi."
  ],
  "Trainee": [
    null,
    "Stagista"
  ],
  "Try again": [
    null,
    "Riprova"
  ],
  "Ts&Cs": [
    null,
    "Termini e Condizioni"
  ],
  "Ts&Cs for the offer": [
    null,
    "Termini e Condizioni dell'offerta"
  ],
  "Type of cash-out": [
    null,
    "Tipo di prelievo"
  ],
  "Type of document": [
    null,
    "Tipo di documento"
  ],
  "Unable to load profile information.": [
    null,
    "Impossibile caricare dati profilo."
  ],
  "Unable to send verification message.": [
    null,
    "Impossible inviare messaggio di verifica."
  ],
  "Unauthorised email.": [
    null,
    "La tua email non è autorizzata."
  ],
  "Unemployed": [
    null,
    "Disoccupato"
  ],
  "Up to": [
    null,
    "Fino a"
  ],
  "Up to a limit of €100 or the same amount as your first deposit": [
    null,
    "Nel limite dell'importo del tuo primo deposito e fino a 100€"
  ],
  "Up to €100 free, instantly!": [
    null,
    "Prima scommessa subito rimborsata fno a 100€!"
  ],
  "Upload an identity document to continue registration.": [
    null,
    "Aggiungi un documento di identità per poter continuare l'iscrizione."
  ],
  "Upload my ID": [
    null,
    "Carica documento"
  ],
  "Upload my verification document": [
    null,
    "Carica documento"
  ],
  "Upload your bank document": [
    null,
    "Carica documento bancario"
  ],
  "Use France Connect": [
    null,
    "Usa France Connect"
  ],
  "Use my existing deposit limit. If none is available, the limit set by you above will be applied.": [
    null,
    "Voglio utilizzare il mio limite di deposito esistente. Se non hai un limite di deposito già esistente, verrà utilizzato il limite da te indicato."
  ],
  "Used or married name": [
    null,
    "Cognome d'uso o maritale"
  ],
  "Username": [
    null,
    "Username"
  ],
  "Validate": [
    null,
    "Conferma"
  ],
  "Validate my deposit": [
    null,
    "Conferma deposito"
  ],
  "Validate my information": [
    null,
    "Conferma"
  ],
  "Validate my limit": [
    null,
    "Conferma limite"
  ],
  "Validate my username": [
    null,
    "Conferma username"
  ],
  "Validation code": [
    null,
    "Codice di validazione"
  ],
  "Verification": [
    null,
    "Verifica"
  ],
  "Verify your phone number to receive a new text message with your validation code.": [
    null,
    "Verifica il tuo numero di telefono per ricevere un nuovo SMS con il tuo codice di validazione."
  ],
  "Want to start playing? Make a deposit now.": [
    null,
    "Vuoi cominciare a giocare? Effettua subito un deposito."
  ],
  "Want to<br />create a<br />username?": [
    null,
    "Vuoi<br />creare un<br />username?"
  ],
  "We are also offering a bonus of equal value to your first deposit.": [
    null,
    "Ti offriamo anche un bonus equivalente al tuo primo deposito."
  ],
  "We cannot accept land-line numbers.": [
    null,
    "Non possiamo accettare numeri di rete fissa."
  ],
  "We will refund your 1st bet up to €100.": [
    null,
    "Ti rimborsiamo la tua scommessa fino a 100€."
  ],
  "We're fetching your data...": [
    null,
    "Stiamo recuperando i tuoi dati..."
  ],
  "We're missing your identity documents to complete your registration.": [
    null,
    "Per completare la tua iscrizione abbiamo bisogno del tuo documento di identità."
  ],
  "Weekly betting limits": [
    null,
    "Limiti di gioco settimanali"
  ],
  "Welcome bonus": [
    null,
    "Bonus di benvenuto"
  ],
  "Welcome to Winamax": [
    null,
    "Benvenuto su Winamax"
  ],
  "Welcome<br />to<br />Winamax!": [
    null,
    "Benvenuto<br />su<br />Winamax!"
  ],
  "What is France Connect": [
    null,
    "Che cos'è France Connect?"
  ],
  "With 168h per week, you can play for an unlimited period": [
    null,
    "Con 168 ore a settimana puoi giocare senza limiti"
  ],
  "Withdrawable cash credited to your account directly after the result of the first bet": [
    null,
    "Somma prelevabile sul tuo conto di gioco subito dopo il risultato della prima scommessa"
  ],
  "Without a professional activity": [
    null,
    "Inattivo"
  ],
  "You are already registered.": [
    null,
    "Hai già effettuato l'accesso."
  ],
  "You are not authorized to access this service.": [
    null,
    "Non sei autorizzato ad accedere a questo servizio."
  ],
  "You are not permitted to create an account from this country.": [
    null,
    "Non è possibile creare un conto da questo paese."
  ],
  "You are not permitted to create this user account.": [
    null,
    "Creazione del conto impossibile."
  ],
  "You are on the Interior Ministry's banned player list!": [
    null,
    "Il tuo nome compare nella lista dei giocatori interdetti al gioco."
  ],
  "You can change this option at any time from your account": [
    null,
    "Puoi annullare la tua iscrizione in ogni momento"
  ],
  "You can continue playing on Winamax in the meantime.": [
    null,
    "Nel frattempo puoi continuare a giocare su Winamax."
  ],
  "You can deposit now to discover our poker and sports betting offer!": [
    null,
    "Adesso puoi depositare e scoprire le nostre offerte poker e scommesse!"
  ],
  "You can finally risk it for that big accumulator!": [
    null,
    "Approfittante per giocarti una grande multipla!"
  ],
  "You can only upload one file at a time. Choose wisely!": [
    null,
    "Puoi caricare un solo file alla volta. Scegli saggiamente!"
  ],
  "You can send this to us at a later time, but you must enter your information now.": [
    null,
    "Inserisci i tuoi dati personali, potrai inviarci il documento in un secondo momento."
  ],
  "You cannot create an account from your country.": [
    null,
    "Non puoi creare un conto di gioco dal tuo paese."
  ],
  "You have already transferred this file.": [
    null,
    "Hai già inviato questo file."
  ],
  "You have entered an invalid domiciliation code": [
    null,
    "Codice di domiciliazione non valido."
  ],
  "You have entered an invalid phone number.": [
    null,
    "Numero di telefono non valido."
  ],
  "You have insufficient CAPTCHA score to continue. Please try again later.": [
    null,
    "Risultato CAPTCHA insufficiente. Ti preghiamo di riprovare più tardi."
  ],
  "You have successfully added your identity document. Please ensure the information you have entered is correct and fill out your postal address.": [
    null,
    "Il tuo documento di identità è stato caricato correttamente. Ti invitiamo ad assicurarti che i dati inseriti siano corretti."
  ],
  "You have successfully made a request to change your password. Please check your emails.": [
    null,
    "Modifica della password avvenuta con successo. Ti invitiamo a controllare le tue email."
  ],
  "You must accept our Ts&Cs in order to create your account.": [
    null,
    "Devi accettare i Termini e Condizioni per creare il tuo conto."
  ],
  "You must certify that you own this bank account.": [
    null,
    "Devi dimostrare che sei il proprietario di questo conto bancario."
  ],
  "You must choose a betting stakes limit in order to start playing.": [
    null,
    "Devi scegliere un limite di puntata per iniziare a giocare."
  ],
  "You must choose a deposit limit in order to make a deposit.": [
    null,
    "Devi inserire un limite di deposito per effettuare un deposito."
  ],
  "You must choose a password.": [
    null,
    "Devi scegliere una password."
  ],
  "You must choose a playtime limit in order to start playing.": [
    null,
    "Per iniziare a giocare è necessario scegliere un limite di tempo di gioco."
  ],
  "You must choose a poker stakes limit in order to start playing.": [
    null,
    "Per iniziare a giocare a poker è necessario scegliere un limite di puntata."
  ],
  "You must choose an automatic withdrawal limit in order to start playing.": [
    null,
    "Per iniziare a giocare è necessario scegliere un limite di prelievo automatico."
  ],
  "You must choose an option for your sex in order to create your account.": [
    null,
    "Devi selezionare il tuo sesso per creare il tuo conto."
  ],
  "You must enter a deposit amount.": [
    null,
    "Devi inserire un importo di deposito."
  ],
  "You must enter an email or a phone number.": [
    null,
    "Devi inserire una email o un numero di telefono."
  ],
  "You must enter an iban number.": [
    null,
    "Devi inserire un IBAN."
  ],
  "You must enter the full name displayed on your bank card in order to validate your deposit.": [
    null,
    "Per effettuare il deposito devi inserire il nome completo che compare sulla carta."
  ],
  "You must enter your activation code in order to validate your account.": [
    null,
    "Devi inserire il tuo codice di attivazione per validare il tuo conto."
  ],
  "You must enter your bank card cryptogram in order to validate your deposit.": [
    null,
    "Per effettuare il deposito devi inserire il criptogramma della carta."
  ],
  "You must enter your bank card expiry date in order to validate your deposit.": [
    null,
    "Per effettuare il deposito devi inserire la data di scadenza della carta."
  ],
  "You must enter your bank card number in order to validate your deposit.": [
    null,
    "Per effettuare il deposito devi inserire il numero di carta."
  ],
  "You must enter your city of birth in order to create your account.": [
    null,
    "Devi inserire il tuo luogo di nascita per creare il tuo conto."
  ],
  "You must enter your city of residence in order to create your account.": [
    null,
    "Devi inserire il tuo luogo di residenza per creare il tuo conto."
  ],
  "You must enter your country of birth in order to create your account.": [
    null,
    "Devi inserire il tuo paese di nascita per creare il tuo conto."
  ],
  "You must enter your country of residence in order to create your account.": [
    null,
    "Devi inserire il tuo paese di residenza per creare il tuo conto."
  ],
  "You must enter your date of birth in order to create your account.": [
    null,
    "Devi inserire la tua data di nascita per creare il tuo conto."
  ],
  "You must enter your department of birth in order to create your account.": [
    null,
    "Devi inserire la tua provincia di nascita per creare il tuo conto."
  ],
  "You must enter your email in order to create your account.": [
    null,
    "Per creare il tuo conto devi inserire una email."
  ],
  "You must enter your identity document number.": [
    null,
    "Inserisci il numero del documento di identità."
  ],
  "You must enter your phone number in order to create your account.": [
    null,
    "Per poter creare il tuo conto devi inserire un numero di telefono."
  ],
  "You must enter your postal address in order to create your account.": [
    null,
    "Devi inserire il tuo indirizzo per creare il tuo conto."
  ],
  "You must enter your postal code in order to create your account.": [
    null,
    "Devi inserire il tuo codice postale per creare il tuo conto."
  ],
  "You must enter your province to create your account.": [
    null,
    "Devi indicare la tua provincia per creare un conto."
  ],
  "You must not be connected to the Winamax Poker software (desktop or mobile)": [
    null,
    "Non devi essere connesso al software Winamax Poker (desktop o mobile)"
  ],
  "You must provide your first name in order to create your account.": [
    null,
    "Devi inserire il tuo nome per creare il tuo conto."
  ],
  "You must provide your last name in order to create your account.": [
    null,
    "Devi inserire il tuo cognome per creare il tuo conto."
  ],
  "You must provide your second last name in order to create your account.": [
    null,
    "Devi inserire il tuo secondo cognome per creare il tuo conto di gioco."
  ],
  "You must upload your bank document.": [
    null,
    "Devi caricare il tuo documento bancario."
  ],
  "You need a username to play on Winamax.": [
    null,
    "Per giocare su Winamax devi scegliere un username."
  ],
  "You need to provide us with your ID and proof of address in order to complete your registration.": [
    null,
    "Per completare la tua iscrizione devi invicarci un tuo documento di identità."
  ],
  "You need to provide us with your ID in order to complete your registration.": [
    null,
    "Per completare l'iscrizione devi inviarci un tuo documento d'identità."
  ],
  "You will receive an activation code by post at the following address:": [
    null,
    "Riceverai un codice di attivazione al seguente indirizzo:"
  ],
  "You're too old!": [
    null,
    "Sei troppo vecchio!"
  ],
  "You're too young!": [
    null,
    "Sei troppo giovane!"
  ],
  "You're way too young!": [
    null,
    "Sei troppo giovane!"
  ],
  "Your ID upload has encountered an error": [
    null,
    "Errore nel caricamento del documento"
  ],
  "Your ID was registered successfully": [
    null,
    "Il tuo documento è stato registrato con successo"
  ],
  "Your account is being validated. You will receive a notification once your documents have been verified.": [
    null,
    "Il tuo conto è stato convalidato. Riceverai una notifica quando il tuo documento sarà verificato. "
  ],
  "Your account is frozen.": [
    null,
    "Il tuo conto è bloccato."
  ],
  "Your account is reloaded,<br /><b>you can continue playing on Winamax</b>": [
    null,
    "Il tuo conto è stato ricaricato,<br /><b>puoi continuare a giocare su Winamax</b>"
  ],
  "Your account validation is being processed. You will be notified when your documents have been validated.": [
    null,
    "Il tuo conto è in corso di validazione. Riceverai una notifica quando il tuo documento sarà stato validato."
  ],
  "Your address is not valid.": [
    null,
    "Indirizzo non valido."
  ],
  "Your automatic withdrawal limit cannot be over %1$s digits.": [
    null,
    "Il prelievo automatico non può essere superiore a %1$s cifre."
  ],
  "Your automatic withdrawal limit is too big.": [
    null,
    "Il tuo limite di prelievo automatico è troppo elevato."
  ],
  "Your automatic withdrawal limit must be greater than or equal to your deposit limit.": [
    null,
    "La tua soglia di prelievo automatico deve essere superiore o uguale al tuo limite di deposito."
  ],
  "Your automatic withdrawal limit must be more than €200.": [
    null,
    "Il tuo limite di prelievo automatico deve essere superiore a 200€."
  ],
  "Your automatic withdrawal limit must be over €0.": [
    null,
    "Il prelievo automatico deve essere più di 0€."
  ],
  "Your bank card cryptogram is not valid.": [
    null,
    "Criptogramma non valido."
  ],
  "Your bank card expiry date is not valid.": [
    null,
    "Data di scadenza non valida."
  ],
  "Your bank card number is not valid": [
    null,
    "Numero di carta non valido"
  ],
  "Your bet refunded in": [
    null,
    "Approfitta di una scommessa rimborsata in"
  ],
  "Your betting stakes limit is too big.": [
    null,
    "Il limite delle tue puntate è troppo elevato."
  ],
  "Your betting stakes limit must be more than €0.": [
    null,
    "Il limite delle tue puntate deve essere superiore a 0€."
  ],
  "Your betting stakes limit per week is not valid.": [
    null,
    "Limite di puntata settimanale scommesse sportive non valido."
  ],
  "Your city cannot be over %1$s characters.": [
    null,
    "Il luogo di nascita non può superare i %1$s caratteri."
  ],
  "Your city is not valid.": [
    null,
    "Luogo di nascita non valido."
  ],
  "Your city is required.": [
    null,
    "Luogo di nascita obbligatorio."
  ],
  "Your city of birth cannot be over %1$s characters.": [
    null,
    "Il tuo luogo di nascita non può superare i %1$s caratteri."
  ],
  "Your city of birth is not valid.": [
    null,
    "Luogo di nascita non valido."
  ],
  "Your coordinates": [
    null,
    "I tuoi dati"
  ],
  "Your country cannot be over %1$s characters.": [
    null,
    "Il paese non può superare i %1$s caratteri."
  ],
  "Your country is not valid.": [
    null,
    "Luogo di nascita non valido."
  ],
  "Your country is required.": [
    null,
    "Luogo di nascita obbligatorio."
  ],
  "Your country of birth is not valid.": [
    null,
    "Paese di nascita non valido."
  ],
  "Your date of birth is not valid.": [
    null,
    "Data di nascita non valida."
  ],
  "Your date of birth must include 4 numbers.": [
    null,
    "La data di nascita deve contenere quattro numeri."
  ],
  "Your department of birth cannot be over %1$s characters.": [
    null,
    "La tua provincia di nascita non può superare i %1$s caratteri."
  ],
  "Your department of birth is not valid.": [
    null,
    "Provincia di nascita non valida."
  ],
  "Your deposit cannot be more than your weekly deposit limit: €%1$s.": [
    null,
    "Il deposito non può essere maggiore del tuo limite di deposito settimanale: %1$s€."
  ],
  "Your deposit limit has been registered. <b>in 48 hours, you will be able to make larger deposits</b>": [
    null,
    "Il tuo limite di deposito è stato salvato. <b>In caso vorrai aumentarlo dovrai attendere 7 giorni prima che la modifica sia valida</b>"
  ],
  "Your deposit limit is too big.": [
    null,
    "Il tuo limite di deposito è troppo alto."
  ],
  "Your deposit limit must be more than €0.": [
    null,
    "Il limite di deposito deve essere più di 0€."
  ],
  "Your deposit limit per week is not valid.": [
    null,
    "Limite di deposito settimanale non valido."
  ],
  "Your deposit must be over €0.": [
    null,
    "Il deposito deve essere maggiore di 0€."
  ],
  "Your document failed to upload": [
    null,
    "Caricamento del documento non riuscito"
  ],
  "Your email cannot be over %1$s characters.": [
    null,
    "L'email non può superare i %1$s caratteri."
  ],
  "Your email is not valid.": [
    null,
    "Email non valida."
  ],
  "Your file is too big. Try again with a file smaller than %1$s Mb.": [
    null,
    "File troppo pesante. Riprova con un file più leggero di %1$s MB."
  ],
  "Your first bet refunded in cash if it loses": [
    null,
    "La tua prima scommessa rimborsata se perdente"
  ],
  "Your first name cannot be over %1$s characters.": [
    null,
    "Il tuo nome non può superare i %1$s caratteri."
  ],
  "Your first name is not valid.": [
    null,
    "Nome non valido."
  ],
  "Your identity": [
    null,
    "Identità"
  ],
  "Your identity corresponds to that of a minor.": [
    null,
    "La tua identità corrisponde a quella di una persona minorenne."
  ],
  "Your identity corresponds to that of someone who has been registered as being deceased.": [
    null,
    "La tua identità corrisponde a quella di una persona deceduta."
  ],
  "Your information is being processed!": [
    null,
    "I tuoi dati sono in fase di elaborazione!"
  ],
  "Your initial deposit in Freebets, up to €100*": [
    null,
    "Il tuo deposito in freebet fino a 100€*"
  ],
  "Your last name cannot be over %1$s characters.": [
    null,
    "Il tuo cognome non può superare i %1$s caratteri."
  ],
  "Your last name is not valid.": [
    null,
    "Cognome non valido."
  ],
  "Your limit cannot be €0": [
    null,
    "Il limite non può essere 0€"
  ],
  "Your limit for %1$s must be inferior or equal to %2$s": [
    null,
    "Il limite per il tuo %1$s deve essere inferiore o uguale a %2$s"
  ],
  "Your limit for %1$s must be set between %2$s and %3$s": [
    null,
    "Il limite per il tuo %1$s deve essere compreso tra %2$s e %3$s"
  ],
  "Your limit for %1$s must be superior or equal to %2$s": [
    null,
    "Il limite per il tuo %1$s deve essere superiore o uguale a %2$s"
  ],
  "Your limit for %1$s must be superior or equal to your %2$s limit": [
    null,
    "Il limite per il tuo %1$s deve essere superiore o uguale al limite per la tua %2$s"
  ],
  "Your limit must be inferior or equal to %1$s": [
    null,
    "Il tuo limite deve essere inferiore o uguale a %1$s"
  ],
  "Your limit must be set between %1$s and %2$s": [
    null,
    "Il tuo limite deve essere compreso tra %1$s e %2$s"
  ],
  "Your limit must be superior or equal to %1$s": [
    null,
    "Il tuo limite deve essere superiore o uguale a %1$s"
  ],
  "Your name in the rankings will be:": [
    null,
    "Dunque il tuo nome in classifica sarà:"
  ],
  "Your number will only be used to identify you": [
    null,
    "Il tuo numero sarà utilizzato solo per identificarti"
  ],
  "Your password cannot be over %1$s characters.": [
    null,
    "La tua password non può superare i %1$s caratteri."
  ],
  "Your password is not valid.": [
    null,
    "Password non valida."
  ],
  "Your password must contain at least %1$s characters.": [
    null,
    "La password deve contenere almeno %1$s caratteri."
  ],
  "Your payment": [
    null,
    "Pagamento"
  ],
  "Your phone number is mandatory in order to receive a new code.": [
    null,
    "Numero di telefono obbligatorio per ricevere un nuovo codice."
  ],
  "Your playtime limit must be more than 0 hours.": [
    null,
    "Il limite di tempo di gioco deve essere superiore a 0 ore."
  ],
  "Your poker stakes limit is too big.": [
    null,
    "Il limite delle tue puntate è troppo elevato."
  ],
  "Your poker stakes limit must be more than €0.": [
    null,
    "Il limite delle tue puntate deve essere superiore a 0€."
  ],
  "Your poker stakes limit per week is not valid.": [
    null,
    "Limite di puntata settimanale poker non valido."
  ],
  "Your postal address cannot be over %1$s characters.": [
    null,
    "L'indirizzo non può superare i %1$s caratteri."
  ],
  "Your postal address is required.": [
    null,
    "Indirizzo obbligatorio."
  ],
  "Your postal code cannot be over %1$s characters.": [
    null,
    "Il codice postale non può superare i %1$s caratteri."
  ],
  "Your postal code is required.": [
    null,
    "Codice postale obbligatorio."
  ],
  "Your proof of address cannot be over one year old.": [
    null,
    "Il giustificativo di domicilio deve essere stato rilasciato da non più di un anno."
  ],
  "Your session has expired.": [
    null,
    "La sessione è scaduta."
  ],
  "Your state is not valid.": [
    null,
    "Paese non valido."
  ],
  "Your story begins here!": [
    null,
    "La tua storia comincia qui!"
  ],
  "Your turn to play": [
    null,
    "Tocca a te!"
  ],
  "Your turn<br />to play": [
    null,
    "Tocca<br />a te!"
  ],
  "Your username cannot contain over %1$s characters.": [
    null,
    "L'username deve contenere massimo %1$s caratteri."
  ],
  "Your username is not valid, the only authorized special characters are: .&_- and space.": [
    null,
    "Username non valido. I caratteri speciali autorizzati sono \".\", \"&\", \"_\", \"-\" e spazio."
  ],
  "Your username must contain at least %1$s characters.": [
    null,
    "L'username deve contenere almeno %1$s caratteri."
  ],
  "Your validation code is incorrect.": [
    null,
    "Codice di validazione non corretto."
  ],
  "Your zip code is not valid.": [
    null,
    "Codice postale non valido."
  ],
  "Your zip code of birth is not valid.": [
    null,
    "Codice postale non valido."
  ],
  "and": [
    null,
    "e"
  ],
  "and the": [
    null,
    "e le"
  ],
  "as well as our": [
    null,
    "e i nostri"
  ],
  "is being processed...": [
    null,
    "in fase di elaborazione..."
  ],
  "of a super-player in progress...": [
    null,
    "del super giocatore in corso..."
  ],
  "of the ongoing payment...": [
    null,
    "del pagamento in corso..."
  ],
  "of your bank card processing...": [
    null,
    "della tua carta di credito/debito in corso..."
  ],
  "or": [
    null,
    "o"
  ],
  "poker": [
    null,
    "poker"
  ],
  "promotions": [
    null,
    "promozioni"
  ],
  "sports betting": [
    null,
    "scommesse"
  ],
  "your document upload...": [
    null,
    "del documento caricato..."
  ]
}
  }
}
